import { Component } from '@theme/component'
import { ThemeEvents } from '@theme/events'
import { ProductFormConfig } from '@theme/product-form-config'

export class AddToCartComponent extends Component {
  requiredRefs = ['addToCartButton']

  #animationTimeout

  #cleanupTimeout

  #loadingTimeout

  connectedCallback() {
    super.connectedCallback()
    document.addEventListener(
      ThemeEvents.cartDrawerOpen,
      this.#clearLoadingState
    )
    document.addEventListener(ThemeEvents.cartError, this.#clearLoadingState)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    if (this.#animationTimeout) {
      clearTimeout(this.#animationTimeout)
    }
    if (this.#cleanupTimeout) {
      clearTimeout(this.#cleanupTimeout)
    }
    if (this.#loadingTimeout) {
      clearTimeout(this.#loadingTimeout)
    }
    document.removeEventListener(
      ThemeEvents.cartDrawerOpen,
      this.#clearLoadingState
    )
    document.removeEventListener(ThemeEvents.cartError, this.#clearLoadingState)
  }

  disable() {
    this.refs.addToCartButton.disabled = true
  }

  enable() {
    this.refs.addToCartButton.disabled = false
  }

  handleClick() {
    const form = this.closest('form')
    if (!form?.checkValidity()) {
      return
    }
    this.#setLoadingState()
    this.animateAddToCart()

    const customCursor = document.querySelector('custom-cursor')
    customCursor?.setLoading(ProductFormConfig.animationDuration)
  }

  #setLoadingState() {
    const { addToCartButton } = this.refs
    addToCartButton.classList.add(ProductFormConfig.classes.loading)
    addToCartButton.setAttribute('aria-busy', 'true')

    if (this.#loadingTimeout) {
      clearTimeout(this.#loadingTimeout)
    }
    this.#loadingTimeout = setTimeout(
      this.#clearLoadingState,
      ProductFormConfig.loadingFallbackTimeout
    )
  }

  #clearLoadingState = () => {
    const { addToCartButton } = this.refs
    addToCartButton.classList.remove(ProductFormConfig.classes.loading)
    addToCartButton.removeAttribute('aria-busy')

    if (this.#loadingTimeout) {
      clearTimeout(this.#loadingTimeout)
      this.#loadingTimeout = undefined
    }
  }

  animateAddToCart() {
    const { addToCartButton } = this.refs
    if (this.#animationTimeout) {
      clearTimeout(this.#animationTimeout)
    }
    if (this.#cleanupTimeout) {
      clearTimeout(this.#cleanupTimeout)
    }
    if (!addToCartButton.classList.contains(ProductFormConfig.classes.added)) {
      addToCartButton.classList.add(ProductFormConfig.classes.added)
    }
    this.#animationTimeout = setTimeout(() => {
      this.#cleanupTimeout = setTimeout(() => {
        this.refs.addToCartButton.classList.remove(
          ProductFormConfig.classes.added
        )
      }, ProductFormConfig.cleanupTimeout)
    }, ProductFormConfig.animationDuration)
  }
}

if (!customElements.get('add-to-cart')) {
  customElements.define('add-to-cart', AddToCartComponent)
}
